import {
  GetSnapshot,
  PostSnapshotByPeriodo,
  PutSnapshotEvaluacion,
  DeleteSnapshotEvaluacion,
  GetResumen,
  PutCambiarVendedor,
  State as ComisionAnualidadState
} from "../../../reducers/comisionAnualidad";

export interface ReporteGerenteGeneralStore
  extends GetSnapshot,
    PostSnapshotByPeriodo,
    PutSnapshotEvaluacion,
    DeleteSnapshotEvaluacion,
    GetResumen,
    PutCambiarVendedor {}

export const reporteGerenteGeneralStore: (
  state
) => ReporteGerenteGeneralStore = state => {
  const comisionAnualidad: ComisionAnualidadState = state.comisionAnualidad;

  return {
    snapshot: comisionAnualidad.snapshot,
    gettingSnapshot: comisionAnualidad.gettingSnapshot,
    gettingSnapshotError: comisionAnualidad.gettingSnapshotError,

    postSnapshotResult: comisionAnualidad.postSnapshotResult,
    postingSnapshotByPeriodo: comisionAnualidad.postingSnapshotByPeriodo,
    postingSnapshotByPeriodoError:
      comisionAnualidad.postingSnapshotByPeriodoError,

    putSnapshotEvaluacionResult: comisionAnualidad.putSnapshotEvaluacionResult,
    puttingSnapshotEvaluacion: comisionAnualidad.puttingSnapshotEvaluacion,
    puttingSnapshotEvaluacionError:
      comisionAnualidad.puttingSnapshotEvaluacionError,

    deleteSnapshotEvaluacionResult:
      comisionAnualidad.deleteSnapshotEvaluacionResult,
    deletingSnapshotEvaluacion: comisionAnualidad.deletingSnapshotEvaluacion,
    deletingSnapshotEvaluacionError:
      comisionAnualidad.deletingSnapshotEvaluacionError,

    resumenSnapshot: comisionAnualidad.resumenSnapshot,
    gettingResumenSnapshot: comisionAnualidad.gettingResumenSnapshot,
    gettingResumenSnapshotError: comisionAnualidad.gettingResumenSnapshotError,

    cambiarVendedorResult: comisionAnualidad.cambiarVendedorResult,
    puttingCambiarVendedor: comisionAnualidad.puttingCambiarVendedor,
    puttingCambiarVendedorError: comisionAnualidad.puttingCambiarVendedorError
  };
};
